// Services Australia: an IHI can be requested online through myGov with a
// passport and a valid Australian visa (the applicant must be in Australia).
export const GET_IHI_INTRO =
  'Get one on myGov with your passport and a valid Australian visa.'

export const GET_IHI_STEPS = [
  'Sign in to myGov, or create an account.',
  'Select “View and link services”, then “Link” on Individual Healthcare Identifiers.',
  'Choose “I need an IHI” and follow the prompts.',
  'Enter your IHI above.',
] as const
